// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
}

.hero {
  padding: 30px 25px 25px;
  color: var(--ion-color-main);
  text-align: left;
}
.hero h1 {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 22px;
  line-height: 33px;
  text-transform: uppercase;
  margin: 10px 0px 5px;
}
.hero p {
  font-family: AppFontLight, sans-serif;
  color: rgba(47, 51, 58, 0.7);
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
}

.search-bar ion-input {
  color: var(--ion-color-main) !important;
  background: #FFFFFF;
}

.search-bar {
  border: 1px solid #e5e5e5;
  border-radius: 7px;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

.start-icon {
  margin-inline-end: 12px;
}

.search-container ion-col {
  padding: 0 !important;
  border-radius: var(--ion-border-radius);
}

.no-place {
  padding: 16px 9px;
  font-family: AppFont-bold, sans-serif;
  background: #FFFFFF;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: var(--ion-border-radius);
  font-size: 12px;
  line-height: 131.5%;
}

.suggested-place {
  border-radius: 7px;
  border: 1px solid #D5DDDD;
  background: #F7F9F9;
  place-items: center;
  padding: 15px 20px;
  margin-top: 5px;
  text-align: left;
}
.suggested-place .navigate-icon {
  margin-right: 15px;
  fill: var(--ion-color-primary) !important;
}
.suggested-place .actual-position-title {
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  font-family: AppFontSemiBold, sans-serif;
}
.suggested-place .actual-position {
  font-size: 13px;
  margin-top: 5px;
  line-height: 16px;
  color: #6D7075;
  font-family: AppFontLight, sans-serif;
}

#buttonContainer {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.vertical-space-around {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.cnt-btn {
  width: 100%;
  padding: 16px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: white;
  font-weight: bold;
  letter-spacing: 0.075em;
  text-transform: uppercase;
  cursor: pointer;
  margin: 0;
  background: var(--ion-color-primary);
  border-radius: 50px;
}
@media (min-width: 991px) {
  .cnt-btn {
    margin: auto;
  }
}

.geo-btn {
  background: #62ABA4;
  font-family: AppFont-bold, sans-serif;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  text-align: center;
  letter-spacing: 0.075em;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.geo-btn ion-icon {
  width: 22px;
  height: 25px;
  margin-right: 10px;
}
@media (min-width: 991px) {
  .geo-btn {
    width: 600px;
    margin: auto;
  }
}

.heading-text {
  font-size: 19px;
  color: var(--ion-text-color);
  font-weight: 500;
  line-height: 145%;
  margin: 20px 0 10px;
}
.heading-text.desktop {
  display: block;
}
@media (max-width: 992px) {
  .heading-text.desktop {
    display: none;
  }
}
.heading-text.mobile {
  display: none;
}
@media (max-width: 992px) {
  .heading-text.mobile {
    display: block;
  }
}

.sub-heading {
  font-size: 18px;
  line-height: 134%;
  margin: 0;
}

.footer-btn {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: white;
}

ion-footer,
.footer-btn {
  background: unset;
  padding: 0 28px 26px !important;
}
@media (min-width: 991px) {
  ion-footer,
  .footer-btn {
    margin: 0px 50px 0 !important;
    width: calc(100% - 100px) !important;
  }
}
ion-footer .button,
.footer-btn .button {
  flex: 1;
  background: var(--ion-color-primary) !important;
  color: white !important;
  text-align: center;
}
ion-footer .button:first-child,
.footer-btn .button:first-child {
  margin-right: 3px;
}
ion-footer .button:last-child,
.footer-btn .button:last-child {
  margin-left: 3px;
}
ion-footer .button.active,
.footer-btn .button.active {
  transition: 0.3s linear;
  background: var(--ion-color-main);
  color: var(--ion-text-color);
}
ion-footer .button.active:hover,
.footer-btn .button.active:hover {
  transition: 0.3s linear;
  background: var(--ion-color-main);
}

.desktop {
  display: none;
  margin: 50px 25px;
}
@media (min-width: 991px) {
  .desktop {
    display: block;
  }
}
.desktop .hero {
  background: white;
  border: 0.5px solid #E5E5E5;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  border-radius: 10px;
}

.mobile {
  display: none;
}
@media (max-width: 992px) {
  .mobile {
    display: block;
  }
}

.logo-block {
  width: 100%;
  display: flex;
  justify-content: center;
}
.logo-block ion-img {
  width: 76px;
}
@media (max-width: 992px) {
  .logo-block {
    display: none;
  }
}

@media (min-width: 991px) {
  .desktop-hero {
    text-align: center;
    margin: 50px 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/check-delivery-radius-modal/check-delivery-radius-modal.component.scss"],"names":[],"mappings":"AAWA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAVF;;AAcA;EACE,uBAAA;EACA,4BAAA;EACA,gBAAA;AAXF;AAYE;EACE,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;AAVJ;AAYE;EACE,qCAAA;EACA,4BAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAVJ;;AAcA;EACE,uCAAA;EACA,mBAAA;AAXF;;AAcA;EACE,yBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAXF;;AAaA;EACE,uBAAA;AAVF;;AAaA;EACE,qBAAA;EACA,uCAAA;AAVF;;AAaA;EACE,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAVF;AAWE;EACE,kBAAA;EACA,yCAAA;AATJ;AAYE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,wCAAA;AAVJ;AAaE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;AAXJ;;AAgBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAbF;;AAgBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;AAbF;AApHE;EAqHF;IAcI,YAAA;EAXF;AACF;;AAcA;EACE,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAXF;AAaE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAXJ;AA9IE;EAuIF;IAsBI,YAAA;IACA,YAAA;EAXF;AACF;;AAcA;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAXF;AAaE;EACE,cAAA;AAXJ;AAzJE;EAmKA;IAGI,aAAA;EATJ;AACF;AAYE;EACE,aAAA;AAVJ;AAjKE;EA0KA;IAGI,cAAA;EARJ;AACF;;AAYA;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AATF;;AAYA;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;AATF;;AAYA;;EAEE,iBAAA;EACA,+BAAA;AATF;AA9LE;EAoMF;;IAMI,6BAAA;IACA,oCAAA;EAPF;AACF;AASE;;EACE,OAAA;EACA,+CAAA;EACA,uBAAA;EACA,kBAAA;AANJ;AAQI;;EACE,iBAAA;AALN;AAQI;;EACE,gBAAA;AALN;AAQI;;EACE,uBAAA;EACA,iCAAA;EACA,4BAAA;AALN;AAOM;;EACE,uBAAA;EACA,iCAAA;AAJR;;AASA;EACE,aAAA;EAKA,iBAAA;AAVF;AApOE;EAwOF;IAGI,cAAA;EAHF;AACF;AAME;EACE,iBAAA;EACA,2BAAA;EACA,+CAAA;EACA,mBAAA;AAJJ;;AAOA;EACE,aAAA;AAJF;AA7OE;EAgPF;IAGI,cAAA;EAFF;AACF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AADF;AAEE;EACE,WAAA;AAAJ;AA3PE;EAsPF;IAQI,aAAA;EACF;AACF;;AAtQE;EAuQF;IAEI,kBAAA;IACA,iBAAA;EAEF;AACF","sourcesContent":["@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n.close-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n\n.hero {\n  padding: 30px 25px 25px;\n  color: var(--ion-color-main);\n  text-align: left;\n  h1 {\n    font-family: AppFontSemiBold, sans-serif;\n    font-size: 22px;\n    line-height: 33px;\n    text-transform: uppercase;\n    margin: 10px 0px 5px;\n  }\n  p {\n    font-family: AppFontLight, sans-serif;\n    color: rgba(47, 51, 58, 0.7);\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 15px;\n  }\n}\n\n.search-bar ion-input {\n  color: var(--ion-color-main) !important;\n  background: #FFFFFF;\n\n}\n.search-bar {\n  border: 1px solid #e5e5e5;\n  border-radius: 7px;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n}\n.start-icon{\n  margin-inline-end: 12px;\n}\n\n.search-container ion-col {\n  padding: 0 !important;\n  border-radius: var(--ion-border-radius);\n}\n\n.no-place {\n  padding: 16px 9px;\n  font-family: AppFont-bold, sans-serif;\n  background: #FFFFFF;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: var(--ion-border-radius);\n  font-size: 12px;\n  line-height: 131.5%;\n}\n\n.suggested-place {\n  border-radius: 7px;\n  border: 1px solid #D5DDDD;\n  background: #F7F9F9;\n  place-items: center;\n  padding: 15px 20px;\n  margin-top: 5px;\n  text-align: left;\n  .navigate-icon {\n    margin-right: 15px;\n    fill: var(--ion-color-primary) !important;\n  }\n\n  .actual-position-title {\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: uppercase;\n    color: var(--ion-color-primary);\n    font-family: AppFontSemiBold, sans-serif;\n  }\n\n  .actual-position {\n    font-size: 13px;\n    margin-top: 5px;\n    line-height: 16px;\n    color: #6D7075;\n    font-family: AppFontLight, sans-serif;\n  }\n}\n\n\n#buttonContainer {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.vertical-space-around {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.cnt-btn {\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n  font-family: AppFontBold, sans-serif;\n  color: white;\n  font-weight: bold;\n  letter-spacing: 0.075em;\n  text-transform: uppercase;\n  cursor: pointer;\n  margin: 0;\n  background: var(--ion-color-primary);\n  border-radius: 50px;\n  @include desktop {\n    margin: auto;\n  }\n}\n\n.geo-btn {\n  background: #62ABA4;\n  font-family: AppFont-bold, sans-serif;\n  color: #ffffff;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n  letter-spacing: 0.075em;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    width: 22px;\n    height: 25px;\n    margin-right: 10px;\n  }\n\n  @include desktop {\n    width: 600px;\n    margin: auto;\n  }\n}\n\n.heading-text {\n  font-size: 19px;\n  color: var(--ion-text-color);\n  font-weight: 500;\n  line-height: 145%;\n  margin: 20px 0 10px;\n\n  &.desktop {\n    display: block;\n    @include mobile() {\n      display: none;\n    }\n  }\n\n  &.mobile {\n    display: none;\n    @include mobile() {\n      display: block;\n    }\n  }\n}\n\n.sub-heading {\n  font-size: 18px;\n  line-height: 134%;\n  margin: 0;\n}\n\n.footer-btn {\n  font-family: AppFontBold, sans-serif;\n  text-transform: uppercase;\n  color: white;\n}\n\nion-footer,\n.footer-btn {\n  background: unset;\n  padding: 0 28px 26px !important;\n\n  @include desktop {\n    margin: 0px 50px 0 !important;\n    width: calc(100% - 100px) !important;\n  }\n\n  .button {\n    flex: 1;\n    background: var(--ion-color-primary) !important;\n    color: white !important;\n    text-align: center;\n\n    &:first-child {\n      margin-right: 3px;\n    }\n\n    &:last-child {\n      margin-left: 3px;\n    }\n\n    &.active {\n      transition: 0.3s linear;\n      background: var(--ion-color-main);\n      color: var(--ion-text-color);\n\n      &:hover {\n        transition: 0.3s linear;\n        background: var(--ion-color-main)\n      }\n    }\n  }\n}\n.desktop {\n  display: none;\n  @include desktop() {\n    display: block;\n  }\n\n  margin: 50px 25px;\n  .hero {\n    background: white;\n    border: 0.5px solid #E5E5E5;\n    box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n    border-radius: 10px;\n  }\n}\n.mobile {\n  display: none;\n  @include mobile() {\n    display: block;\n  }\n}\n.logo-block {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  ion-img {\n    width: 76px;\n  }\n  @include mobile {\n    display: none;\n  }\n}\n.desktop-hero {\n  @include desktop() {\n    text-align: center;\n    margin: 50px 25px;\n  }\n\n}\n// .cross {\n//   fill: var(--ion-color-primary) !important;\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
